module.exports = __webpack_public_path__ + "static/media/copy_link.6b9fcdbe.svg";